import { translations } from '@prezly/theme-kit-intl';
import Link from 'next/link';
import { FormattedMessage } from 'react-intl';

import { useDevice, useThemeSettings } from '@/hooks';
import { IconArrowRight } from 'icons';
import type { StoryWithImage } from 'types';
import { ButtonLink } from 'ui';

import CategoriesList from '../CategoriesList';
import StoryImage from '../StoryImage';
import { StoryPublicationDate } from '../StoryPublicationDate';

import styles from './HighlightedStoryCard.module.scss';

type Props = {
    story: StoryWithImage;
};

function HighlightedStoryCard({ story }: Props) {
    const { categories, title, subtitle } = story;
    const { showDate, showSubtitle } = useThemeSettings();
    const { isTablet } = useDevice();

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <div>
                    <CategoriesList
                        showAllCategories={!isTablet}
                        categories={categories}
                        linkClassName={styles.categoryLink}
                    />
                </div>

                <Link href={`/${story.slug}`} locale={false} className={styles.link}>
                    <h2 className={styles.title}>{title}</h2>
                </Link>

                {subtitle && showSubtitle && <p className={styles.subtitle}>{subtitle}</p>}

                {showDate && (
                    <p className={styles.date}>
                        <StoryPublicationDate story={story} />
                    </p>
                )}

                <ButtonLink
                    className={styles.readMore}
                    href={`/${story.slug}`}
                    icon={IconArrowRight}
                    iconPlacement="right"
                    variation="secondary"
                >
                    <FormattedMessage {...translations.actions.readMore} />
                </ButtonLink>
            </div>

            <Link href={`/${story.slug}`} locale={false} className={styles.imageWrapper}>
                <StoryImage
                    story={story}
                    size="big"
                    className={styles.image}
                    placeholderClassName={styles.placeholder}
                />
            </Link>
        </div>
    );
}

export default HighlightedStoryCard;
